import { render, staticRenderFns } from "./TargetMain.vue?vue&type=template&id=b4f8ba9a"
import script from "./TargetMain.vue?vue&type=script&lang=js"
export * from "./TargetMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports